import {FC, SVGProps} from 'react';

export const NameMismatchPuzzleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="160" height="201" viewBox="0 0 160 201" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			d="M94.318 63.5067L78.7085 69.5079V68.8452V40.4058H50.3494L56.3336 24.752C60.8879 12.8219 52.1038 0 39.3542 0C26.6047 0 17.8206 12.8099 22.3748 24.752L28.3591 40.4058H0L1.86255 41.0685H0V120H28.3591L22.3748 104.346C17.8206 92.4161 26.6047 79.5942 39.3542 79.5942C52.1038 79.5942 60.8879 92.4041 56.3336 104.346L50.3494 120H78.7085V91.5606L94.318 97.5618C106.214 102.129 119 93.3199 119 80.5342C119 67.7485 106.226 58.9395 94.318 63.5067Z"
			fill="black"
		/>
		<path
			d="M159 199.892L158.892 121L134.969 121.036V145.065H104.142V121.084L80.1104 121.108L80.1465 145.065H53V175.935H80.1946L80.2307 200L159 199.892Z"
			fill="#F3F3F3"
			stroke="black"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
	</svg>
);
